import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';
import { DIMENSION_TAG } from '../dimension/createGroupBy';

export const findDimensionDetailsInFilter = (filters, dimensionWithTypes) => {
  const dimensionTypes: any = [];
  const dimensionFields: any = [];
  filters.forEach((rule) => {
    if (Array.isArray(rule) && rule.length > 0) {
      // TODO convert to set or object
      rule.forEach((r) => {
        if (r.field === DIMENSION_TAG && r.key) {
          if (
            dimensionWithTypes[r.key] !== undefined &&
            !dimensionTypes.includes(dimensionWithTypes[r.key])
          ) {
            dimensionTypes.push(dimensionWithTypes[r.key]);
          }
        } else {
          if (
            dimensionWithTypes[r.field] !== undefined &&
            !dimensionTypes.includes(dimensionWithTypes[r.field])
          ) {
            dimensionTypes.push(dimensionWithTypes[r.field]);
          }
        }
        dimensionFields.push(r.field);
      });
    }
  });
  return {
    dimensionTypes,
    dimensionFields,
  };
};

export const findDimensionDetailsInCompareFilters = (filters, dimensionWithTypes) => {
  const dimensionTypes: any = [];
  const dimensionFields: any = [];
  const filterDimensionTypes: any = [];
  filters.forEach((filter, index) => {
    filterDimensionTypes[index] = [];
    Object.values(filter.filters).forEach((rule: any) => {
      if (rule.field === DIMENSION_TAG && rule.key) {
        if (
          dimensionWithTypes[rule.key] !== undefined &&
          !dimensionTypes.includes(dimensionWithTypes[rule.key])
        ) {
          dimensionTypes.push(dimensionWithTypes[rule.key]);
        }
      } else {
        if (dimensionWithTypes[rule.field] !== undefined) {
          dimensionTypes.push(dimensionWithTypes[rule.field]);
          filterDimensionTypes[index].push(dimensionWithTypes[rule.field]);
        }
      }
      dimensionFields.push(rule.field);
    });
  });
  return {
    dimensionTypes: [...new Set(dimensionTypes)],
    dimensionFields: [...new Set(dimensionFields)],
    filterDimensionTypes: filterDimensionTypes,
  };
};

export const getFilterModeFromDimensionTypes = (dimensionTypes) => {
  if (dimensionTypes.includes(DIMENSION_TYPES_CONSTANTS.mutableGlobalMetadata)) {
    return DIMENSION_TYPES_CONSTANTS.mutableGlobalMetadata;
  } else if (dimensionTypes.includes(DIMENSION_TYPES_CONSTANTS.eventTagKeyValueMetadata)) {
    return DIMENSION_TYPES_CONSTANTS.eventTagKeyValueMetadata;
  } else if (dimensionTypes.includes(DIMENSION_TYPES_CONSTANTS.mappedEventName)) {
    return DIMENSION_TYPES_CONSTANTS.mappedEventName;
  } else {
    return DIMENSION_TYPES_CONSTANTS.immutableGlobalMetadata;
  }
};

export const hasMappedEventName = (dimensionTypes) => {
  return dimensionTypes.includes(DIMENSION_TYPES_CONSTANTS.mappedEventName);
};
